import { matchPath } from 'react-router-dom';

// 在url中提取出pathname /(?<!(\/|:))\/[^?.#:]*/
// url中的域名 /^(?:https?:\/\/)?(\w+(?:\.\w+)+)/

/**
 * 判断两个路径是否相等
 *
 * @param path1
 * @param path2
 * @param strict
 * @example
 *
 * strictEqualPath('/a', '/a/')
 * // true
 *
 * strictEqualPath('/a', '/a/', true)
 * // false
 */
function strictEqualPath(path1: string, path2: string, strict = false): boolean {
  if (typeof path1 !== 'string' || typeof path2 !== 'string') return false;

  if (strict) return path1 === path2;

  if (path1 === path2) return true;

  // 如果长度相等，但两个值不相等，那么直接返回false
  if (path1.length === path2.length) return false;

  const discLen = path1.length - path2.length;

  if (Math.abs(discLen) !== 1) return false;

  if (discLen > 0) return path1[path1.length - 1] === '/';
  else return path2[path2.length - 1] === '/';
}

/**
 * 是否是子路径
 *
 * @param parentPath
 * @param childPath
 * @example
 *
 * isChildPath('/', '/a')
 * // true
 *
 * isChildPath('/*', '/a')
 * true
 *
 * isChildPath('/*\/*\/a', '/a')
 * false
 */
function isChildPath(parentPath: string, childPath: string): boolean {
  if (typeof parentPath !== 'string' || typeof childPath !== 'string') return false;

  return !!matchPath(childPath, { path: parentPath });
}

export { strictEqualPath, isChildPath };
